import Grid from "@mui/material/Grid"

export default function GridItem({fullWidth = false, children, ...props}) {
  return (
    <Grid item xs={12} md={fullWidth ? 12 : 6} {...props}>
      {children}
    </Grid>
  )
}
